import { combineEpics } from "redux-observable";
import { conversationEpic } from "./Conversation";
import { notificationEpic } from "./Notification";
import { signinEpic } from "./Signin";
import { signupEpic } from "./Signup";

export const rootEpic = combineEpics(
  signupEpic,
  signinEpic,
  conversationEpic,
  notificationEpic
);
